<template>
    <card class="card-plain">
        <form>
            <div class="card-body row pt-0">
                <div class="col-12 p-0">
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="col-xl-12">
                                <legend>{{$t('Team Basics')}}</legend>
                                <div class="row">
                                    <div class="col-xl-7">
                                        <fg-input name="title"
                                                  :label="$t('Title')"
                                                  autocomplete="off"
                                                  required
                                                  :error="getError('title')"
                                                  v-model="team.title"
                                                  v-validate="validations.title"
                                                  :placeholder="$t('Title')">
                                        </fg-input>
                                    </div>
                                    <div class="col-xl-5">
                                        <fg-input :label="$t('Team Visibility')" name="visibility" required
                                                  v-model="team.visibility"
                                                  v-validate="validations.visibility" :error="getError('visibility')">
                                            <el-select size="large"
                                                       class="select-primary"
                                                       :placeholder="$t('Visibility')"
                                                       v-model="team.visibility">
                                                <el-option v-for="option in ['detailed', 'accumulated']"
                                                           :value="option"
                                                           :label="$t(option)"
                                                           :key="option">
                                                </el-option>
                                            </el-select>
                                        </fg-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="col-xl-12">
                                <legend>{{$t('Owner')}}</legend>
                                <fg-input name="owner"
                                          required
                                          :value="team.owner ? team.owner._id : null"
                                          v-validate="validations.owner"
                                          :error="getError('owner')">
                                    <input-picker v-model="team.owner" data-type="user" :label="$t('Group Owner')"/>
                                </fg-input>
                            </div>
                            <div class="col-xl-12">
                                <list class="p-0" v-model="team.leaders" :title="$t('Leaders')"
                                      :columns="columnsBy.leaders"
                                      :actions="actionsBy.leaders"
                                      :remove="(props) => remove('leaders', props.$index)"/>
                            </div>
                            <div class="col-xl-12">
                                <list class="p-0" v-model="team.members" :title="$t('Members')"
                                      :columns="columnsBy.members"
                                      :actions="actionsBy.members"
                                      :remove="(props) => remove('members', props.$index)"/>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="col-xl-12">
                                <legend>{{$t('Team Configuration')}}</legend>
                                <list class="p-0" v-model="team.questionnaires" :title="$t('Questionnaires')"
                                      :columns="columnsBy.questionnaires"
                                      :actions="actionsBy.questionnaires"
                                      :remove="(props) => remove('questionnaires', props.$index)"/>
                            </div>

<!--                            <div class="col-xl-12">-->
<!--                                <list class="p-0" v-model="team.tags && team.tags.map(tag => ({title: tag}))"-->
<!--                                      :title="$t('Tags')"-->
<!--                                      :columns="columnsBy.tags"-->
<!--                                      :actions="actionsBy.tags"-->
<!--                                      :remove="(props) => remove('tags', props.$index)"/>-->
<!--                            </div>-->

                            <div class="col-xl-12">
                                <legend>{{$t('Team Organization')}}</legend>
                                <list class="p-0" v-model="team.childTeams"
                                      :title="$t('Sub Teams')"
                                      :columns="columnsBy.childTeams"
                                      :actions="actionsBy.childTeams"
                                      :remove="(props) => remove('childTeams', props.$index)"/>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div class="card-footer text-right actions">
                <p-button round native-type="button" class="btn-wd btn-one-size-dropdown button-distance" :disabled="loading"
                          @click.prevent="$router.push({ name: 'TeamList' })">{{$t('cancel')}}
                </p-button>
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd btn-one-size-dropdown" :disabled="loading" @click.prevent="save">
                    {{$t('Save')}}
                </p-button>
            </div>
        </form>
        <team-modal :value="team" :show="showDialog" :type="modalType" :cancel="cancel"/>
    </card>
</template>

<script>
  import { TeamProfile } from 'src/store/models/Team'
  import { Input, Button, Select, Option } from 'element-ui'
  import List from '../../Components/BasicList'
  import TeamModal from './TeamModal'
  import InputPicker from '../../Components/InputPicker'

  export default {
    name: 'TeamForm',

    components: {
      InputPicker,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      List,
      TeamModal
    },

    data () {
      return {
        team: new TeamProfile(),
        loading: false,
        showDialog: false,
        columnsBy: {
          tags: [{ name: 'title', text: 'Title', sortable: true, align: 'left' }],
          questionnaires: [{ name: 'title', formatter: this.languageFormatter, text: 'Title', sortable: true, align: 'left' }],
          leaders: [
            { name: 'user.username', text: 'Username', sortable: true, align: 'left' },
            { name: 'createdAt', text: 'Added at', formatter: this.dateFormatter, sortable: true, align: 'left', minWidth: 120 }
          ],
          members: [
            { name: 'user.username', text: 'Username', sortable: true, align: 'left' },
            { name: 'createdAt', text: 'Added at', formatter: this.dateFormatter, sortable: true, align: 'left' }
          ],
          childTeams: [{ name: 'title', text: 'Name', sortable: false, align: 'left' }],
        },
        actionsBy: {
          tags: [{label: 'Add Team Tag', click: () => this.openModal('tags')}],
          questionnaires: [{label: 'Add questionnaire', click: () => this.openModal('questionnaires')}],
          leaders: [{label: 'Add Leader', click: () => this.openModal('leaders')}],
          members: [{label: 'Add Member', click: () => this.openModal('members')}],
          childTeams: [{label: 'Add Sub Team', click: () => this.openModal('childTeams')}]
        },
        modalType: '',
        validations: {
          title: {
            required: true,
            min: 5
          },
          owner: {
            required: true,
          },
          visibility: {
            required: true,
          }
        },
      }
    },

    async mounted () {
      await this.initData()
    },

    methods: {
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (user) {
        return this.$options.filters.formatUser(user)
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      async initData () {
        if (this.$route.name === 'TeamCreate') {
          this.team = new TeamProfile({ visibility: 'detailed' })
        } else {
          await this.fetchTeam()
        }
      },
      async fetchTeam () {
        if (!this.teamId) {
          return
        }
        try {
          this.loading = true
          const result = await TeamProfile.api().get(`/team/${this.teamId}`, { save: false })
          this.team = new TeamProfile(result.response.data)
        } catch (e) { console.log('e', e)} finally {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.$t(this.errors.first(fieldName))
      },
      save: async function () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          this.$notify({ message: this.$t('Invalid form. Check fields.'), type: 'danger' })
          return
        }

        const { title, visibility, owner, tags } = this.team
        const leaders = this.team.leaders.map(o => ({ ...o, user: o.user._id }))
        const members = this.team.members.map(o => ({ ...o, user: o.user._id }))
        const questionnaires = this.team.questionnaires.map(o => o._id)
        const childTeams = this.team.childTeams.map(o => o._id)
        const data = { title, visibility, owner, leaders, members, tags, questionnaires, childTeams }
        try {
          if (this.team._id) {
            const result = await TeamProfile.api().put(`/team/${this.teamId}`, data, { save: false })
            this.team = new TeamProfile(result.response.data)

            this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

          } else {

            const result = await TeamProfile.api().post(`/team`, data, { save: false })
            this.team = new TeamProfile(result.response.data)

            if (result.response.data._id) {
              this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })
              this.$router.push({ name: 'TeamEdit', params: { id: result.response.data._id } })
            }
          }
        } catch (e) {
          this.$notify({ message: e.message, type: 'danger' })
        }
      },
      openModal: async function (type) {
        this.showDialog = true
        this.modalType = type
      },
      remove: function (type, index) {
        this.team[type].splice(index, 1)
      },
      cancel: function () {
        this.showDialog = false
      }
    },

    watch: {
      showDialog (val) {
        if (!val) {
          this.modalType = ''
        }
      }
    },

    computed: {
      teamId: function () {
        return this.$route.params.id || ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-distance {
    margin-right: 10px !important;
  }

  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }

      .card-footer {
        padding: 0px;
      }

      .button-distance {
        margin-bottom: 10px !important;
      }
    }
</style>